<template>
  <!-- -->
  <div class="btn-exit" :style="{'font-size': settingData.textSize, 'color': settingData.textColor, 'height': data.height}">
    {{settingData.text}}
  </div>
</template>

<script>

import YqIcon from "@/components/YqIcon.vue";
import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
import {watch} from "vue";
import AloneTextOnImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneTextOnImage.vue";
import util from "@/util/util";
export default {
  props: {
    data: {
      default: () => {
        return {}
      }
    },
  },
  name: "",
  components: {
    YqIcon, AloneTextOnImage, AloneImage
  },
  data() {
    return {
      userInfo: {},
      settingData: [],
    };
  },
  created() {
    util.getUserInfo().then(res => {
      this.userInfo = res;
    });
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {
          text: "退出登录",
        };
      } else {
        this.settingData = this.data.componentData;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.btn-exit {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
}
</style>